import _ from 'lodash';
import { combineReducers } from "redux";
import { fork, all } from 'redux-saga/effects';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension';
import {persistenceMiddleware} from 'storeState/persistence/middleware';
import persistance from './persistence';

import ui from './ui';

import tenants from "./tenants";
import auth from "./auth";
import projects from "./projects";
import general from "./general";
import users from "./users";
import translations from "./translations";

export default function initStore() {
    const sagaMiddleware = createSagaMiddleware();

    const combinedReducer = combineReducers({
        ui: ui.reducer,
        auth: auth.reducer,
        tenants: tenants.reducer,
        projects: projects.reducer,
        general: general.reducer,
        users: users.reducer,
        translations: translations.reducer,
        localPersistence: persistance.reducer,
    });

    const rootReducer = (state,action) => {
        if(action.type == persistance.constant.LOAD_REDUX_STORE_FROM_LOCAL_STORAGE) {
            return persistance.reducer(state, action);
        } else {
            return combinedReducer(state, action);
        }
    }

    const store = createStore(rootReducer, composeWithDevTools(
        applyMiddleware(sagaMiddleware, persistenceMiddleware),
    ));

    var n_errors = 0
    const max_errors = 20;

    function* rootSaga() {
        console.log("(re-)starting rootSaga");
        try {
            yield all([
                fork(auth.saga),
                fork(tenants.saga),
                fork(projects.saga),
                fork(general.saga),
                fork(users.saga),
                fork(translations.saga),
                fork(ui.saga),
            ]);
        } catch (e) {
            n_errors++;
            console.log("Error While executing Saga", e);
            if(n_errors < max_errors) {
                yield all([
                    fork(rootSaga)
                ])
            }
        }
    }

    sagaMiddleware.run(rootSaga);

    return {
        store,
    };
}



// WEBPACK FOOTER //
// ./src/storeState/index.js